/* Casa Antonio en Casa — navegación, modalidad y cesta */
(function(){
  var d=document, root=d.documentElement;
  root.classList.add('ca-js');
  var $=function(s,c){return (c||d).querySelector(s)}, $$=function(s,c){return Array.prototype.slice.call((c||d).querySelectorAll(s))};
  var store={get:function(k){try{return JSON.parse(localStorage.getItem(k))}catch(e){return null}},set:function(k,v){try{localStorage.setItem(k,JSON.stringify(v))}catch(e){}}};
  var money=function(c){return (c/100).toLocaleString('es-ES',{style:'currency',currency:'EUR'})};
  var esc=function(s){return String(s).replace(/[&<>"]/g,function(m){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[m]})};

  var platos=$('[data-ca-platos]'), cartEl=$('#ca-cart');
  var LABEL={pickup:platos?platos.getAttribute('data-pickup-label'):'Recoger en Jaén',ship:platos?platos.getAttribute('data-ship-label'):'Envío a casa'};
  var cfg=cartEl?cartEl.dataset:{};
  var FEE=Math.round(parseFloat(String(cfg.fee||'0').replace(',','.'))*100)||0;
  var FREE=Math.round(parseFloat(String(cfg.free||'0').replace(',','.'))*100)||0;
  var list=function(s){return String(s||'').split(',').map(function(x){return x.trim()}).filter(Boolean)};

  /* Catálogo leído de las tarjetas */
  var cat={};
  $$('.ca-card[data-key]').forEach(function(c){
    cat[c.dataset.key]={el:c,title:c.dataset.title,format:c.dataset.format,price:parseInt(c.dataset.price,10)||0,variant:c.dataset.variant||'',pickup:c.dataset.pickup==='true',ship:c.dataset.ship==='true',soldout:c.dataset.soldout==='true'};
  });

  var saved=store.get('ca_cart')||{};
  var st={mode:saved.mode||(platos&&platos.getAttribute('data-mode'))||'pickup',items:{},day:saved.day||'',slot:saved.slot||''};
  Object.keys(saved.items||{}).forEach(function(k){if(cat[k]&&saved.items[k]>0)st.items[k]=Math.min(20,saved.items[k])});
  if(/[#&]envio/.test(location.hash))st.mode='ship';
  var save=function(){store.set('ca_cart',st)};

  function lines(){return Object.keys(st.items).map(function(k){var p=cat[k];return {k:k,p:p,q:st.items[k],ok:st.mode==='ship'?p.ship:p.pickup}})}
  function totals(){
    var ls=lines(),n=0,sub=0;ls.forEach(function(l){n+=l.q;sub+=l.q*l.p.price});
    var fee=st.mode==='ship'&&n?(FREE&&sub>=FREE?0:FEE):0;
    return {ls:ls,n:n,sub:sub,fee:fee,total:sub+fee,blocked:ls.some(function(l){return !l.ok})};
  }
  function add(k,delta){
    var p=cat[k];if(!p||p.soldout)return;
    var q=(st.items[k]||0)+delta;
    if(q<=0)delete st.items[k];else st.items[k]=Math.min(20,q);
    save();render();
    if(delta>0&&navigator.vibrate)try{navigator.vibrate(12)}catch(e){}
  }
  function setMode(m){if(m!=='pickup'&&m!=='ship')return;st.mode=m;save();render()}

  /* Pintado */
  var bar,sheet;
  function render(){
    var t=totals();
    if(platos)platos.setAttribute('data-mode',st.mode);
    $$('[data-ca-mode]').forEach(function(b){b.setAttribute('aria-pressed',b.getAttribute('data-ca-mode')===st.mode)});
    Object.keys(cat).forEach(function(k){
      var p=cat[k],q=st.items[k]||0;
      p.el.setAttribute('data-qty',q);
      p.el.classList.toggle('is-off',!(st.mode==='ship'?p.ship:p.pickup));
      var o=$('[data-ca-out]',p.el);if(o)o.textContent=q;
    });
    $$('.ca-bag__n').forEach(function(b){b.textContent=t.n;b.setAttribute('data-n',t.n)});
    if(bar){
      $('[data-bar-total]',bar).textContent=t.n?money(t.total):LABEL[st.mode];
      $('[data-bar-sub]',bar).textContent=t.n?(t.n+(t.n===1?' plato · ':' platos · ')+LABEL[st.mode]):'Recogida en Jaén o envío a casa';
      $('[data-bar-btn]',bar).textContent=t.n?'Ver pedido':'Ver la carta';
      updateBar();
    }
    if(sheet)renderSheet(t);
  }

  function renderSheet(t){
    var body=$('.ca-sheet__body',sheet),foot=$('.ca-sheet__foot',sheet),h='';
    h+='<div class="ca-mode" role="group" aria-label="Modalidad"><button type="button" data-ca-mode="pickup" aria-pressed="'+(st.mode==='pickup')+'">'+esc(LABEL.pickup)+'</button><button type="button" data-ca-mode="ship" aria-pressed="'+(st.mode==='ship')+'">'+esc(LABEL.ship)+'</button></div>';
    if(!t.n){
      h+='<p class="ca-empty">Aún no has añadido ningún plato.</p>';
    }else{
      t.ls.forEach(function(l){
        h+='<div class="ca-line"><div><div class="ca-line__f">'+esc(l.p.format)+'</div><div class="ca-line__t">'+esc(l.p.title)+'</div></div><div class="ca-line__p">'+money(l.q*l.p.price)+'</div>'+
          '<div class="ca-qty"><button type="button" data-ca-dec="'+l.k+'" aria-label="Quitar uno">−</button><output>'+l.q+'</output><button type="button" data-ca-inc="'+l.k+'" aria-label="Añadir uno">+</button></div>'+
          (l.ok?'':'<div class="ca-line__warn">No disponible para '+esc(LABEL[st.mode].toLowerCase())+'. <button type="button" class="ca-link" data-ca-del="'+l.k+'">Quitar</button></div>')+'</div>';
      });
      if(st.mode==='pickup'){
        var opt=function(arr,sel,ph){return '<option value="">'+ph+'</option>'+arr.map(function(x){return '<option'+(x===sel?' selected':'')+'>'+esc(x)+'</option>'}).join('')};
        h+='<div class="ca-row2"><label class="ca-field"><span>Día</span><select data-ca-day>'+opt(list(cfg.days),st.day,'Elige día')+'</select></label><label class="ca-field"><span>Franja</span><select data-ca-slot>'+opt(list(cfg.slots),st.slot,'Elige franja')+'</select></label></div>';
        if(cfg.pickupNote)h+='<p class="ca-sheet__note" style="text-align:left">'+esc(cfg.pickupNote)+'</p>';
      }else if(FREE){
        var left=FREE-t.sub,pct=Math.min(100,Math.round(t.sub/FREE*100));
        h+='<div class="ca-free">'+(left>0?'Te faltan <b>'+money(left)+'</b> para el envío gratis':'<b>Tienes el envío gratis</b>')+'<i><b style="width:'+pct+'%"></b></i></div>';
        if(cfg.shipNote)h+='<p class="ca-sheet__note" style="text-align:left">'+esc(cfg.shipNote)+'</p>';
      }
    }
    body.innerHTML=h;
    var needSlot=st.mode==='pickup'&&(!st.day||!st.slot);
    var allVariants=t.n&&t.ls.every(function(l){return l.p.variant});
    var f='';
    if(t.n){
      f+='<div class="ca-sum"><span>Platos</span><span>'+money(t.sub)+'</span></div>';
      f+='<div class="ca-sum"><span>'+(st.mode==='ship'?'Envío refrigerado':'Recogida en el restaurante')+'</span><span>'+(st.mode==='ship'?(t.fee?money(t.fee):'Gratis'):'Gratis')+'</span></div>';
      f+='<div class="ca-sum ca-sum--total"><span>Total</span><b>'+money(t.total)+'</b></div>';
    }
    var label=!t.n?'Ver la carta':t.blocked?'Quita los platos no disponibles':needSlot?'Elige día y franja':allVariants?'Finalizar pedido':'Enviar pedido por WhatsApp';
    var dis=t.n&&(t.blocked||needSlot);
    f+='<button type="button" class="ca-btn ca-btn--gold" data-ca-go'+(dis?' disabled':'')+'>'+label+'</button>';
    if(t.n)f+='<p class="ca-sheet__note">'+(allVariants?'Pago seguro en el siguiente paso. IVA incluido.':'Te confirmamos disponibilidad y pago por WhatsApp. IVA incluido.')+'</p>';
    foot.innerHTML=f;
  }

  function checkout(){
    var t=totals();
    if(!t.n){closeSheet();var pl=$('#platos');if(pl)pl.scrollIntoView({behavior:'smooth'});return}
    if(t.blocked||(st.mode==='pickup'&&(!st.day||!st.slot)))return;
    var allVariants=t.ls.every(function(l){return l.p.variant});
    if(allVariants){
      var path='/cart/'+t.ls.map(function(l){return l.p.variant+':'+l.q}).join(',');
      var qs='attributes[Modalidad]='+encodeURIComponent(LABEL[st.mode]);
      if(st.mode==='pickup')qs+='&attributes[D%C3%ADa%20de%20recogida]='+encodeURIComponent(st.day)+'&attributes[Franja]='+encodeURIComponent(st.slot);
      location.href=path+'?'+qs;return;
    }
    var m='Hola, quiero hacer un pedido en Casa Antonio en Casa.\n\n*'+LABEL[st.mode]+'*';
    if(st.mode==='pickup')m+=' · '+st.day+' · '+st.slot;
    m+='\n\n';
    t.ls.forEach(function(l){m+='• '+l.q+' × '+l.p.title+' ('+l.p.format+') — '+money(l.q*l.p.price)+'\n'});
    m+='\nPlatos: '+money(t.sub);
    if(st.mode==='ship')m+='\nEnvío: '+(t.fee?money(t.fee):'gratis');
    m+='\n*Total: '+money(t.total)+'*';
    if(st.mode==='ship')m+='\n\nDirección de entrega: ';
    window.open('https://wa.me/'+String(cfg.wa||'').replace(/\D/g,'')+'?text='+encodeURIComponent(m),'_blank');
  }

  /* Hoja de pedido */
  var lastFocus=null;
  function openSheet(){if(!sheet)return;lastFocus=d.activeElement;render();sheet.classList.add('is-open');sheet.setAttribute('aria-hidden','false');d.body.classList.add('ca-lock');updateBar();var x=$('.ca-sheet__x',sheet);if(x)x.focus()}
  function closeSheet(){if(!sheet)return;sheet.classList.remove('is-open');sheet.setAttribute('aria-hidden','true');d.body.classList.remove('ca-lock');updateBar();if(lastFocus&&lastFocus.focus)lastFocus.focus()}

  /* Barra fija: aparece con productos en la cesta o al pasar la portada */
  var hero=$('.ca-hero'),ticking=false;
  function updateBar(){
    if(!bar)return;
    var n=totals().n,past=hero?hero.getBoundingClientRect().bottom<80:window.scrollY>400;
    var inPlatos=false;
    if(!n&&platos){var r=platos.getBoundingClientRect();inPlatos=r.top<innerHeight*.6&&r.bottom>innerHeight*.4}
    var open=sheet&&sheet.classList.contains('is-open');
    bar.classList.toggle('is-on',!open&&(n>0||(past&&!inPlatos)));
  }
  window.addEventListener('scroll',function(){if(!ticking){ticking=true;requestAnimationFrame(function(){updateBar();ticking=false})}},{passive:true});

  /* Eventos */
  d.addEventListener('click',function(e){
    var t=e.target.closest('.ca-nav__toggle');
    if(t){var n=t.closest('.ca-nav');var o=n.classList.toggle('is-open');t.setAttribute('aria-expanded',o);return}
    if(e.target.closest('.ca-nav__links a')){var nav=$('.ca-nav');if(nav)nav.classList.remove('is-open')}
    var el;
    if((el=e.target.closest('[data-ca-mode]'))){setMode(el.getAttribute('data-ca-mode'));return}
    if((el=e.target.closest('[data-ca-go-mode]'))){setMode(el.getAttribute('data-ca-go-mode'))}
    if((el=e.target.closest('[data-ca-inc]'))){add(el.getAttribute('data-ca-inc'),1);return}
    if((el=e.target.closest('[data-ca-dec]'))){add(el.getAttribute('data-ca-dec'),-1);return}
    if((el=e.target.closest('[data-ca-del]'))){delete st.items[el.getAttribute('data-ca-del')];save();render();return}
    if(e.target.closest('[data-ca-cart-open]')){e.preventDefault();openSheet();return}
    if(e.target.closest('[data-ca-cart-close]')){closeSheet();return}
    if(e.target.closest('[data-ca-go]')){checkout();return}
    if((el=e.target.closest('[data-bar-btn]'))){if(totals().n)openSheet();else{var pl=$('#platos');if(pl)pl.scrollIntoView({behavior:'smooth'})}}
  });
  d.addEventListener('change',function(e){
    if(e.target.matches('[data-ca-day]')){st.day=e.target.value;save();render()}
    if(e.target.matches('[data-ca-slot]')){st.slot=e.target.value;save();render()}
  });
  d.addEventListener('keydown',function(e){if(e.key==='Escape'&&sheet&&sheet.classList.contains('is-open'))closeSheet()});

  /* Deslizar hacia abajo para cerrar la hoja */
  if(cartEl){
    bar=$('.ca-bar',cartEl);sheet=$('.ca-sheet',cartEl);
    var panel=$('.ca-sheet__panel',cartEl),y0=null;
    $('.ca-sheet__head',cartEl).addEventListener('touchstart',function(e){y0=e.touches[0].clientY},{passive:true});
    $('.ca-sheet__head',cartEl).addEventListener('touchmove',function(e){if(y0===null)return;var dy=e.touches[0].clientY-y0;if(dy>0)panel.style.transform='translateY('+dy+'px)'},{passive:true});
    $('.ca-sheet__head',cartEl).addEventListener('touchend',function(e){if(y0===null)return;var dy=e.changedTouches[0].clientY-y0;panel.style.transform='';y0=null;if(dy>90)closeSheet()});
  }
  render();

  /* Aparición suave (solo escritorio) */
  var els=$$('[data-ca-reveal]');
  if(!('IntersectionObserver' in window)||matchMedia('(max-width:760px)').matches){els.forEach(function(el){el.classList.add('is-in')});return}
  var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){x.target.classList.add('is-in');io.unobserve(x.target)}})},{threshold:.12});
  els.forEach(function(el){io.observe(el)});
})();
